export default __webpack_public_path__ + "static/media/7.Боловсролын ерөнхий газрын бүтэц, чиг үүрэг, үндсэн үйл ажиллагаа.f55967e5.png";